import { FC } from 'react'
import type { AwardsModulePanellist } from '../../../types/components'
import ModulePanelPage from '../ModulePanelPage'
import { ApiPagePage } from '../../../types/contentTypes'

const ModuleAwardsPanelPage: FC<{
  moduleProps: AwardsModulePanellist['attributes']
  landingContentData: ApiPagePage['attributes']
}> = ({ moduleProps }) => {
  return <ModulePanelPage moduleProps={moduleProps} />
}

export default ModuleAwardsPanelPage
